module.exports = __webpack_public_path__ + "static/img/2.937d64a7.png";